module.exports = __webpack_public_path__ + "assets/images/payspace-not-found.6ac7e6b03eef5ab138ca5d692e364720.webp";